import { HttpHeaders } from '@angular/common/http';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ADN_PLUS, AuthService, CtButtonComponent, CtDialogComponent, HttpService, PlusAlertsService } from 'components';
import { ErrorService } from 'src/app/services/error.service';


@Component({
  selector: 'av-vi00',
  templateUrl: './av-vi00.component.html',
  styleUrls: ['./av-vi00.component.css']
})
export class AvVi00Component implements OnInit {

  public step: string;
  public errorToDisplay: string;
  public toCompleteMail;
  public toCompletePhone;

  // Form inputs
  public userIdentifier: string;
  public finaluserIdentifier: string;
  public flushCode: string;
  public password: string;
  public newPassword: any;
  public confirmPassword: any;
  public contactVerify: string;
  public accountStatusId: string;
  public hasAccount: string;
  public customerName: string;
  public numCliente: number;
  public userEmails: string[] = [];
  public userPhones: string[] = [];
  public inputMail: string;
  public inputPhone: string;
  public newContact: string = 'N';
  public newContactInput: string;
  public contactType: string = "";
  public mailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public phonePattern = /^[678]\d\d\d\d\d\d\d/;
  public activeTab: 'mails' | 'phones' = 'mails';

  constructor(
    private authService: AuthService,
    private plusAlertService: PlusAlertsService,
    private errorService: ErrorService,
    private httpService: HttpService,
    private router: Router,
    private cdf : ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.step = 'CHECK';
    this.checkIE();
    this.checkContactsTabs();
  }

  @HostListener('window:hashchange', ['$event'])
  handleHashChange(event: Event) {
    this.updateActiveTabFromUrl(window.location.hash);
  }
  
  private checkContactsTabs() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateActiveTabFromUrl(event.urlAfterRedirects)
      }
    });
  }

  private updateActiveTabFromUrl(url: string) {
    if (url.includes('#mails')) {
      this.activeTab = 'mails';
    } else if (url.includes('#phones')) {
      this.activeTab = 'phones';
    } else {
      this.activeTab = 'mails';
    }
  }

  checkIE() {
    var isIE = false;
    var ua = window.navigator.userAgent;
    var old_ie = ua.indexOf('MSIE ');
    var new_ie = ua.indexOf('Trident/');

    if ((old_ie > -1) || (new_ie > -1)) {
      isIE = true;
    }

    if (isIE) {
      this.plusAlertService.setCtDialogInfo('Navegador incompatible', 'downloadError', 'downloadError', 'primary', 'Estimada persona asociada, hemos detectado un navegador incompatible, le sugerimos actualizar su versión ó realizar el trámite desde Google Chrome, Mozilla firefox o Microsoft Edge.',
        true, 'De acuerdo', 'Cancelar');
    }
  }

  public checkStep(step: string = null): void {
    this.errorToDisplay = null;

    if (step)
      this.step = step;
    else {
      try {
        switch (this.step) {
          case 'CHECK':
            this.checkIdentifier();
            break;
          case 'V_INFO':
          case 'H_INFO':
          case 'N_INFO':
            this.sendOtpCode();
            break;
          default:
          // this.goBack();
        }
      } catch (ex) {
        this.errorService.handleUIError(ex);
      }
    }
  }

  private checkIdentifier(): void {

    if(!this.userIdentifier){
      this.plusAlertService.setCtDialogInfo('documento de identificación', 'inspect', 'inspect', 'primary', 'Estimado(a) asociado(a) el documento de identificación debe ser ingresado.',
      true, 'De acuerdo', 'Cancelar');
      return;
    }

    this.finaluserIdentifier = this.userIdentifier.replace(/-|\s|_/g, '');

    if (!/^(\w|\d){9,20}$/g.test(this.finaluserIdentifier)) {
      this.plusAlertService.setCtDialogInfo('Error', 'error', 'inspect', 'primary', 'Estimado(a) asociado(a) el documento de identificación ingresado debe tener una cantidad entre 9 y 20 caracteres, sin caracteres especiales.\r\n\nPor favor inténtelo nuevamente.',
        true, 'De acuerdo', 'Cancelar');
      return;
    }

    this.authService.getLoginPreviewInfo(this.finaluserIdentifier, 'PRESOL').subscribe((x: any) => {

      let accountStatus = this.authService.utilService.getStringAttribute('STATUS_USR', x.Data[0].ArrayEntities.List);
      let verifiedMail = this.authService.utilService.getStringAttribute('EMAIL', x.Data[0].ArrayEntities.List);
      let verifiedPhone = this.authService.utilService.getStringAttribute('CELULAR', x.Data[0].ArrayEntities.List);
      this.hasAccount = this.authService.utilService.getStringAttribute('IND_EX_USR', x.Data[0].ArrayEntities.List);
      this.customerName = this.authService.utilService.getStringAttribute('NOM_COMPLETO', x.Data[0].ArrayEntities.List);
      this.numCliente = this.authService.utilService.getStringAttribute('NUM_CLIENTE', x.Data[0].ArrayEntities.List);

      if (this.hasAccount === 'S') {
        //Redirecciona a el login de SVA
        this.resetToInitial();
        let ctDialog : CtDialogComponent;
        ctDialog = this.plusAlertService.setCtDialogInfo('Usuario registrado', 'action', 'inspect', 'primary', 'Parece que ya está registrado(a) en nuestra sucursal virtual, será redirigido(a) a la pantalla de inicio de sesión, por favor inicie sesión y continue con su gestión.',
          true, 'De acuerdo', 'Cancelar');
        this.cdf.detectChanges();
        setTimeout(() => {         
          (ctDialog.getChildElements()[0] as CtButtonComponent).clickTimer.subscribe(() => {
            this.router.navigate(['/login']);
          });
        });
      }
      else {
        if ((!verifiedPhone && !verifiedMail) || (verifiedPhone == 'null' && verifiedMail == 'null')) {
          //Va a buscar sin verificar
          this.retContactInfo();
        } else {
          //Si tiene verificados alguno de los 2 y no tiene cuenta
          this.userPhones = verifiedPhone && verifiedPhone != 'null' ? [verifiedPhone] : [];
          this.userEmails = verifiedMail && verifiedMail != 'null' ? [verifiedMail] : [];
          this.toCompleteMail = this.userEmails[0];
          this.toCompletePhone = this.userPhones[0];
          this.step = 'V_INFO';
        }
      }
    },
      (x: any) => {
        if (x.error_code == 'CRED.ERR_PRESOL_DUPLICATE') {
          this.plusAlertService.setCtDialogInfo('Error', 'error','caution', 'primary', x.description,
            true, 'Ir a la sucursal virtual', null), () => {
              this.router.navigate(['/']);
            }
        } else {
          this.plusAlertService.setCtDialogInfo('Error', 'downloadError', 'caution', 'primary', x.description,
            true, 'De acuerdo', 'Cancelar');
        }
      });
  }

  retContactInfo() {
    let contRequest = {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [
          {
            "Name": "NUM_CLIENTE",
            "Alias": "NUM_CLIENTE",
            "Value": this.numCliente,
            "Display": "",
            "Type": 1,
            "FamilyId": ""
          }
        ]
      },
      "Data": []
    }

    let headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'x-api-key': HttpService.APIKEY
    });

    let msgSinDatos = 'Estimada persona asociada, hemos encontrado su número de identificación en nuestra base de datos, pero sin medios de contacto registrados. Agradecemos verificar y en caso de ser necesario actualizar sus datos personales por medio de la central telefónica, cita virtual o en nuestros puntos de servicio.';

    this.httpService.postCustom(HttpService.ENDPOINT + '/api/process/LOCALIZACION/RET_LOC_CLIENTE_PRE_CRED', contRequest, { headers: headers }).subscribe((res) => {
      if (res.Data.length > 0) {
        for (let adn of res.Data) {
          adn = new ADN_PLUS(adn);
          if (adn.getStringAttribute('TIP_LOCALIZACION') == 'C') {
            this.userPhones.push(adn.getStringAttribute('DES_LOCALIZACION'));
          } else if (adn.getStringAttribute('TIP_LOCALIZACION') == 'E') {
            this.userEmails.push(adn.getStringAttribute('DES_LOCALIZACION'));
          }
        }

        if (this.userEmails.length == 0 && this.userPhones.length == 0) {
          //Habilitar el campo para que meta la data
          this.newContact = 'S';
          this.step = 'N_INFO';
          // this.plusAlertService.showAlertDialog('Sin datos', msgSinDatos, 'info', 'De acuerdo');
          // this.resetToInitial();
        } else {
          this.toCompleteMail = this.userEmails[0] || null;
          this.toCompletePhone = this.userPhones[0] || null;
          this.step = 'H_INFO';
        }

      } else {
        this.newContact = 'S';
        this.step = 'N_INFO';
        //Habilitar el campo para que meta la data
        // this.plusAlertService.showAlertDialog('Sin datos', msgSinDatos, 'info', 'De acuerdo');
        // this.resetToInitial();
      }
    });
  }

  sendOtpCode() {

    let loc;

    if (!this.inputMail && !this.inputPhone && !this.newContactInput) {
      throw new Error("Debe ingresar al menos un email o un telefono");
    } else {
      loc = this.inputMail ? this.inputMail : (this.inputPhone ? this.inputPhone : this.newContactInput);
    }


    this.contactType = !this.contactType ? (loc.includes("@") ? "E" : "C") : this.contactType;

    let coreRequest = {
      "Type": 0,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [
          {
            "Name": "DOC_IDENTIFICACION",
            "Alias": "DOC_IDENTIFICACION",
            "Value": this.finaluserIdentifier,
            "Display": "",
            "Type": 1,
            "FamilyId": ""
          },
          {
            "Name": "MEDIA_TARGET",
            "Alias": "MEDIA_TARGET",
            "Value": this.contactType,
            "Display": "",
            "Type": 1,
            "FamilyId": ""
          },
          {
            "Name": "DES_LOCALIZACION",
            "Alias": "DES_LOCALIZACION",
            "Value": loc,
            "Display": "",
            "Type": 1,
            "FamilyId": ""
          },
          {
            "Name": "NEW_LOC",
            "Alias": "NEW_LOC",
            "Value": this.newContact,
            "Display": "",
            "Type": 1,
            "FamilyId": ""
          }
        ]
      },
      "Data": []
    }

    let headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'x-api-key': HttpService.APIKEY
    });

    this.httpService.postCustom(HttpService.ENDPOINT + '/api/process/PRE_SOLICITUD_CRED/SER_SEND_INIT_LINK', coreRequest, { headers: headers }).subscribe(() => {
      this.resetToInitial();
      this.plusAlertService.setCtDialogInfo('Enviado', 'success', 'success', 'primary', 'Hemos enviado un enlace a su correo o teléfono seleccionado',
        true, 'De acuerdo', 'Cancelar');
    })
  }

  resetToInitial() {
    this.step = 'CHECK';
    this.userIdentifier = null;
    this.finaluserIdentifier = null;
    this.customerName = null;
    this.inputMail = null;
    this.inputPhone = null;
    this.newContactInput = null;
    this.newContact = 'N';
    this.contactType = null;
  }

  getInfoMessage() {
    switch (this.step) {
      case 'CHECK':
        return "Para la Sociedad de Seguros de Vida es de suma importancia contar con sus datos actualizados para brindarle un mejor servicio. Le invitamos a actualizar su información a través del siguiente formulario:"
      case 'V_INFO':
        return "Encontramos los siguientes datos verificados en su cuenta, seleccione el medio donde desea recibir un enlace para continuar."
      case 'H_INFO':
        return "Encontramos los siguientes datos registrados en su cuenta, seleccione el medio donde desea recibir un enlace para continuar."
      case 'N_INFO':
        return "No encontramos datos registrados en su cuenta, seleccione el tipo de medio donde desea recibir un enlace para continuar e ingrese el medio en el campo a continuación:"
    }
  }

  getBtnText() {
    switch (this.step) {
      case 'CHECK':
        return "Consultar"
      case 'V_INFO':
      case 'H_INFO':
      case 'N_INFO':
        return "Enviar enlace"
    }
  }

}
